export const surveyChartTooltips = {
  IHA: "In House Acquired ($t(data.acquired.default.IHA))",
  IHAw: "In House Acquired Worsening ($t(data.acquired.default.IHAw))",
  POA: "Present on Admission ($t(data.acquired.default.POA))",
  PIHAw:
    "Present on Admission In House Acquired Worsening ($t(data.acquired.default.PIHAw))"
};
